// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"21":"1a457f1d","22":"339e16c6"}[chunkId] + ".js";
};